import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";

const coachingData = [
  { id: "01.", title: "Vendor Management & Strategic Pricing", description: "Streamline procurement with vetted vendors, fair pricing, and risk-controlled partnerships. We ensure reliable supply and scalable sourcing." },
  { id: "02.", title: "Budget Planning & Financial Oversight", description: "Align your financial goals with smart budgeting, forecasting, and cost control. We help you plan, analyze, and grow sustainably." },
  { id: "03.", title: "Marketing & Advertising Strategy", description: "Boost your brand with targeted campaigns, compelling content, and multi-channel reach. We turn ideas into conversions." },
  { id: "04.", title: "Administration & Staffing Solutions", description: "Simplify operations with professional HR and admin support. Build a team that delivers while staying compliant." },
  { id: "05.", title: "Restaurant Business Consulting", description: "From menus to manpower, we help restaurants grow profitably. Data, tech, and training-all in one plan." },
  { id: "06.", title: "Immigration & Visa Support Services", description: "Navigate Canadian immigration with expert help. For individuals and businesses-get it right, the first time." },
  { id: "07.", title: "Import, Distribution & Delivery-Indian Spices & Grains", description: "With Rojan Canada, we deliver bulk Indian staples to your door—fast, fresh, and reliable." },
  { id: "08.", title: "Social Media & Digital Advertising", description: "Grow your brand online with powerful content and performance-driven ad campaigns tailored to your audience." },
  { id: "09.", title: "Custom Private Label, Printing & Packaging", description: "Make your product shelf-ready with premium labels, eco-packaging, and standout print solutions." },
];

export default function Service() {
  return (
    <div className="coaching_offer">
      <Container>
        <Row>
          <Col md={6}>
            <h5><i class="fa-regular fa-paper-plane" style={{color: '#b80505',transform: 'rotate(45deg)'}}></i> Our services <i class="fa-solid fa-earth-americas" style={{color: '#b50808'}}></i></h5>
            <h1>
            Transformative Services for Business Excellence!
            </h1>
          </Col>
          <Col md={6}>
            <h6 style={{fontSize:'17px',lineHeight:'2',paddingTop:'4.5%'}}>
            By fostering agility, building robust capabilities, and cultivating a forward-thinking culture, we help you deliver exceptional value and achieve sustainable success.  

            </h6>
          </Col>
        </Row>
      </Container>
      <div className="types-of category">
        <Container>
          <Row>
            <Col sm={12} lg={8} md={12} >
              <Row>
                {coachingData.map((item, index) => (
                  <Col md={6} key={index} className="mb-3">
                    <Card className="test-card">
                      <Card.Body>
                        <Card.Title>
                          <h3>
                            <span>{item.id}</span>
                             {item.title}
                          </h3>
                        </Card.Title>
                        <Card.Text className="cart-text">
                            <h6>
                            {item.description}
                            </h6>
                            </Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
            <Col sm={12} lg={4} md={12}>
            {/* <div className="img-service">

            </div> */}
              <img
                src="images/venser.jpeg"
                alt="Business service"
                width={"100%"}
                height={'85%'}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}